/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {

	/**
	 * @interface PaletteAPI
	 * @classdesc API class that defines PaletteService interface
	 */
	class PaletteAPI {
		/**
		 * Gets a palette with the given id from content service
		 * @param {string} id - the ID of the palette to retrieve
		 * @return {Promise} Resolved with the palette or Rejected if the palette wasn't found example below
		 * Resolved value eg:
		 * {
		 *	"defaultName": "demoName",
		 *	"content": {
		 *		"label": "demoName",
		 *		"fillType": "simple",
		 *		"fills": ["#FFD191"]
		 *	},
		 *	"id": "4e40ce98c8a548409880bc459d88ca62",
		 *	"my": true
		 *	}
		 */
		getPalette() { }

		/**
		 * Returns all the palettes found in the content store
		 * @param {String} [fillType] - Specify either 'simple' or 'continuous' palettes to filter the list of palette being returned.  Default will return all the palettes
		 * @return {Promise} Resolved with the all the palettes found example below
		 * Resolved value eg:
		 * {
		 *	my: [{
		 *		"defaultName": "demoName",
		 *		"content": {
		 *			"label": "demoName",
		 *			"fillType": "simple",
		 *			"fills": ["#FFD191"]
		 *		},
		 *		"id": "demoId",
		 *		"my": true
		 *	}]
		 *	public: [{
		 *		"defaultName": "demoName2",
		 *		"content": {
		 *			"label": "demoName2",
		 *			"fillType": "simple2",
		 *			"fills": ["#FFD192"]
		 *		},
		 *		"id": "demoId2",
		 *		"public": true,
		 *	}]
		 */
		getPalettes() { }

		/**
		 * Register an event to the palette feature
		 * @param {string} eventName - supported events: 'palette:deleted' & 'palette:updated'
		 * @param {*} callbackFunction - takes an object containing paletteId as param
		 * eg: callbackFunction( { paletteId } )
		 */
		on() { }

		/**
		 * Deregister an event from the palette feature
		 * @param {string} eventName - supported events: 'palette:deleted' & 'palette:updated'
		 * @param {*} callbackFunction - takes an object containing paletteId as param
		 * eg: callbackFunction( { paletteId } ) 
		 */
		off() { }
	}

	return PaletteAPI;
});
